import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import Button from 'rebook/apps/base/components/Button';
import { pop } from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class BookAddToMyBooks extends React.Component {
  onChangeStatus(bookId, bookTitle, bookType) {
    const isAudio = bookType==='audio';
    const url = '/api/bookuserlist/';
    const params = {
      json: {
        book: `/api/books/${bookId}/`,
        readinglist: 1,
      },
      apiVersion: 4,
      method: 'POST',
    };
    fetchQuery(url, params).then(() => {
      const title = (bookTitle.length > 25) ? `${bookTitle.substr(0, 19)}...` : bookTitle;
      const message = `Книга ${title} добавлена в мои книги`;
      this.props.pop(message, 'thumbsUp');
    }).then(() => {
      this.setState({ readingStatus: 1 });
    }).then(() => {
      yaMetrikaReachGoal(`${isAudio ? 'Audio' : ''}BookAddToCollection`);
      ga('send', 'event', 'BookAddToMyBooks');
      this.props.onChangeStatus();
    }).catch(() => {
      this.onChangeStatusError();
    });
  }

  onChangeStatusError() {
    return this.props.pop('Что-то пошло не так', 'error');
  }

  componentDidUpdate() {
    const { isInstantAdd, afterInstantAdd } = this.props;
    const waitingTimeOutInMs = 3000;

    if (isInstantAdd) {
      // 3 секунды ждём, чтобы юзер заметил баннер добавления в мои книги
      setTimeout(() => {
        const { bookId, bookTitle, bookType } = this.props;

        this.onChangeStatus(bookId, bookTitle, bookType);
        afterInstantAdd();
      }, waitingTimeOutInMs);
    }
  }

  render() {
    const { bookId, bookTitle, bookType, extraClassName } = this.props;
    return (
      <Button
        extraClassName={classNames('cy-addbook-button jest-addbook-button', extraClassName)}
        handleClick={() => this.onChangeStatus(bookId, bookTitle, bookType)}>
        <span className={styles.plus} />
      </Button>
    );
  }
}

BookAddToMyBooks.propTypes = {
  readingStatus: PropTypes.number,
  bookTitle: PropTypes.string,
  bookType: PropTypes.oneOf(['text', 'audio']),
  bookId: PropTypes.number,
  pop: PropTypes.func,
  changeBookStatus: PropTypes.func,
  isInstantAdd: PropTypes.bool,
};

BookAddToMyBooks.defaultProps = {
  readingStatus: 0,
  bookType: 'text',
  bookTitle: '',
  bookId: 0,
  pop: Function.prototype,
  changeBookStatus: Function.prototype,
  isInstantAdd: false,
};

function mapDispatchToProps(dispatch) {
  return {
    pop: (message, type) => dispatch(pop(message, type)),
  };
}

export default connect(null, mapDispatchToProps)(BookAddToMyBooks);
